module.exports = __webpack_public_path__ + "991237e2bca899cdf6419f8ccbc67f28.png";